module.exports = __webpack_public_path__ + "img/selected-invitation-to-mundane-life-2.9af1d8eb.webp";